import { action } from 'typesafe-actions'

export const RECALL_API = 'login/RECALL_API'

export const recallApi = (apiCallback: { callback?: any; errorCode: number }) => action(RECALL_API, apiCallback)
